import { render } from "./IntegrationCard.vue?vue&type=template&id=48ee49fc&ts=true"
import script from "./IntegrationCard.vue?vue&type=script&lang=ts"
export * from "./IntegrationCard.vue?vue&type=script&lang=ts"

import "./IntegrationCard.vue?vue&type=style&index=0&id=48ee49fc&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__